import { render, staticRenderFns } from "./default_home_table.vue?vue&type=template&id=b8151d72&scoped=true"
import script from "./default_home_table.vue?vue&type=script&lang=js"
export * from "./default_home_table.vue?vue&type=script&lang=js"
import style0 from "./default_home_table.vue?vue&type=style&index=0&id=b8151d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8151d72",
  null
  
)

export default component.exports